import React from 'react';
import { Badge } from './ui/badge';

/**
 * FlagIcon — bare country flag (flag-icons CSS, imported in main.jsx).
 *
 * @param {string} geo — ISO 3166-1 alpha-2 country code (e.g. "BR", "US")
 */
export const FlagIcon = ({ geo, className = '' }) => {
    if (!geo) return null;
    return (
        <span
            className={`fi fi-${geo.toLowerCase()} shrink-0 ${className}`}
            style={{
                width: 16,
                height: 12,
                borderRadius: 3,
                overflow: 'hidden',
                display: 'inline-block',
            }}
            aria-hidden="true"
        />
    );
};

/**
 * GeoFlag — Badge with a country flag icon and the country code.
 *
 * @param {string} geo — ISO 3166-1 alpha-2 country code (e.g. "BR", "US")
 */
const GeoFlag = ({ geo, className = '' }) => {
    if (!geo) return null;

    return (
        <Badge
            variant="outline"
            className={`text-[11px] font-normal uppercase py-0.5 h-5 flex items-center gap-1 ${className}`}
        >
            <FlagIcon geo={geo} />
            <span>{geo}</span>
        </Badge>
    );
};

export default GeoFlag;
